import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BaseApiService } from '@app/services/api/base.service';
import { isDevMode } from '@angular/core';
import { CareerDetailResponse, ApiResponse } from '@app/schemas/career-details';

@Injectable({
  providedIn: 'root'
})
export class CareerDetailsService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/navigate-api' : (environment as any).navigateApiUrl || '/navigate-api';
    super(http, apiBaseUrl);
  }

  getCareerDetails(onetSocCode: string): Observable<ApiResponse<CareerDetailResponse>> {
    return this.get<ApiResponse<CareerDetailResponse>>(`careers/${onetSocCode}`);
  }
}